import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency") || "INR" // Default to INR
  );
  const [exchangeRates, setExchangeRates] = useState({});

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/currency-rates`
        );
        setExchangeRates(response.data.rates);
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };
    fetchRates();
  }, []);

  useEffect(() => {
    const fetchUserCurrency = async () => {
      // Only fetch user currency if user is logged in
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      if (!isLoggedIn) {
        return; // Skip API call if not authenticated
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user/getCurrency`,
          { withCredentials: true }
        );
        if (res.data && res.data.currency) {
          setSelectedCurrency(res.data.currency);
          localStorage.setItem("selectedCurrency", res.data.currency);
        }
      } catch (err) {
        // fallback to localStorage/default
      }
    };
    fetchUserCurrency();
  }, []);

  const convertPrice = (basePrice) => {
    const rate = exchangeRates[selectedCurrency] || 1;
    return (basePrice * rate).toFixed(2);
  };

  return (
    <CurrencyContext.Provider
      value={{ selectedCurrency, setSelectedCurrency, convertPrice }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
